import { Col, Row, Switch, Typography } from 'antd';
import { AppProps } from 'presentation/App';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import React, { useEffect } from 'react';

const MFA_ON = '10';
const MFA_OFF = '0';

const CU05401Page = (props: AppProps) => {
    const dispatch = useAppDispatch();

    const [isMFA, setIsMFA] = React.useState<boolean>(false);

    const { userUseCase } = props;

    useEffect(() => {
        (async () => {
            await initiateDefaultData();
        })();
    }, []);

    const initiateDefaultData = async () => {
        try {
            dispatch(startFetching());
            const response = await userUseCase.getUserInfo();

            if (response && response.result) {
                setIsMFA(response.result.mfaSetting == MFA_ON);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const onChange = async (checked: boolean) => {
        try {
            dispatch(startFetching());
            await userUseCase.settingMFA({
                mfa_setting: checked ? MFA_ON : MFA_OFF,
            });
            setIsMFA(checked);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-054-01-container"
        >
            <PageTitle title="MFA認証オプション" />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="corpo-form-container w-full">
                    <div className="section-wrapper ">
                        <Row gutter={[40, 0]} className="h-full">
                            <Col className="text-base max-w-[85%]">
                                <Typography.Text className="text-base">
                                    多要素認証（MFA）を使用してアカウントを保護します。有効の場合、ログイン時に認証コードが求められます。
                                </Typography.Text>
                            </Col>
                            <Col className="text-base">
                                <Switch checked={isMFA} onChange={onChange} />
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CU05401Page;
